import ListTransferRequests from './views/List.vue'
import CreateTransferRequest from './views/Create.vue'
import GetTransferRequest from './views/Get.vue'

export const TransferRequestsRoutes = [
  {
    path: '/transfer-requests',
    name: 'ListTransferRequests',
    component: ListTransferRequests,
    meta: {
      auth: true,
      layout: 'home',
      permission: 'transfer:list'
    }
  },
  {
    path: '/transfer-request',
    name: 'CreateTransferRequest',
    component: CreateTransferRequest,
    meta: {
      auth: true,
      layout: 'home',
      permission: 'transfer:create'
    }
  },
  {
    path: '/transfer-request/:id',
    name: 'GetTransferRequest',
    component: GetTransferRequest,
    meta: {
      auth: true,
      layout: 'home',
      permission: 'transfer:create'
    }
  }
]
